import { useForm, SaveButton, NumberField } from "@refinedev/antd";
import {
  Form,
  Input,
  Col,
  Row,
  Spin,
  Typography,
  Card,
  Checkbox,
  Switch,
  notification,
  message,
  Avatar,
  Tag,
  Collapse,
  Select,
  InputNumber,
  DatePicker,
  Dropdown,
} from "antd";
import { useTranslate } from "@refinedev/core";
import {
  AppstoreOutlined,
  ApiOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseCircleOutlined,
  EditOutlined,
  FilterOutlined,
  SaveOutlined,
  CloseOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Flex, Divider, Button, theme } from "antd";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { axiosInstance } from "@/utilities";
import {
  API_URL_LINKED_IMPORT,
  API_URL_LINKED_SEARCH,
  API_URL_PIM_ATTRIBUTE_SETS,
} from "@/services/XCONS_ENV";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONJUNTOS_DEL_ALTA,
  etiquetaConjunto,
} from "@/pages/catalog/conjuntos";
import VirtualList from "rc-virtual-list";
import { createPortal } from "react-dom";
import { LinkedProductCard } from "@/components";
import noImage from "@/assets/img/no-img.png";
import dayjs from "dayjs";
import { codigoEntreParentesis } from "@/pages/catalog/valores-de-opciones";

const { Search } = Input;
const { Title, Text } = Typography;

interface LinkedProductsProps {
  sellerCode?: string;
  sellerSku?: string;
  linkedData?: any;
  configData?: any;
  mainTableRefecth?: any;
  /** Con más de uno para asociar: en cuál va, para el "2 / 5". */
  posicion?: { actual: number; total: number };
  /** Si quedan más en la cola: Guardar avanza con flecha en vez de terminar con check. */
  haySiguiente?: boolean;
  onAtras?: () => void;
  /** Después de guardar: pasa al siguiente o vuelve a la tabla, lo decide la pantalla. */
  onGuardado?: () => void;
  /**
   * Después de un cambio que no sale de la pantalla —desasociar uno, guardar los datos del
   * producto—: el Historial lo vuelve a pedir.
   */
  onCambio?: () => void;
  /** Dónde van Volver, Catalogar y Guardar: la barra fija de abajo de la pantalla. */
  contenedorDelPie?: HTMLElement | null;
}

export const LinkedProducts: React.FC<LinkedProductsProps> = React.memo(
  ({
    sellerCode,
    configData,
    mainTableRefecth,
    posicion,
    haySiguiente = false,
    onAtras,
    onGuardado,
    onCambio,
    contenedorDelPie,
  }) => {
    const [thisConfigData, setThisConfigData] = useState<any>(configData);
    const [searchValue, setSearchValue] = useState<string>(
      thisConfigData?.name,
    );
    const [textSearchValue, setTextSearchValue] = useState<string>(
      thisConfigData?.name,
    );
    const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
    const [selectedProductData, setSelectedProductData] = useState<object>({});
    const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);
    const [loadingVirual, setLoadingVirual] = useState<boolean>(false);
    const [loadingDrawer, setLoadingDrawer] = useState<boolean>(false);
    const [linkedData, setLinkedData] = useState<any[]>([]);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [activeSale, setActiveSale] = useState<boolean>(true);
    const [isActiveSale, setIsActiveSale] = useState<boolean>(false);
    const [conjuntosDelAlta, setConjuntosDelAlta] = useState<
      Array<{ attributeSetId: number; name: string }>
    >([]);
    const [selectedFilters, setSelectedFilters] = useState<any>({});
    const [screenHeightProduct, setScreenHeightProduct] = useState<number>(0);
    const [screenHeightDetail, setScreenHeightDetail] = useState<number>(0);
    const [filterOptions, setFilterOptions] = useState<any>({
      unit: {},
      color: {},
      avgPrice: {},
      manufacturer: {},
    });
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedData, setEditedData] = useState<any>({});
    const [detailsCollapseKey, setDetailsCollapseKey] = useState<string[]>([]);

    const t = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();

    const [preparandoCatalogar, setPreparandoCatalogar] = useState(false);

    /**
     * Abrir **+ Catalogar** (xcons-docs#611): primero la API le da a quien lo aprieta el
     * Catálogo "Por participación" si nunca lo tuvo, y recién después se piden los conjuntos —
     * los dos tipos que se pueden dar de alta, los mismos del Nuevo producto del Catálogo—.
     * En ese orden porque los conjuntos los sirve el Catálogo: pedidos al montar, quien todavía
     * no entraba recibía 403 y el botón quedaba deshabilitado. El borrador nace en el primer
     * Guardar del alta, y ahí queda su Admin y dueño.
     */
    const prepararCatalogar = async () => {
      if (conjuntosDelAlta.length || preparandoCatalogar) return;
      setPreparandoCatalogar(true);
      try {
        const { data: acceso } = await axiosInstance.post(
          `${API_URL_LINKED_SEARCH}/${sellerCode}/catalogar`,
        );
        if (acceso?.nivel === "no_access") {
          message.error(
            "No tenés acceso al Catálogo: pedíselo a un Admin del Catálogo",
          );
          return;
        }
        const { data } = await axiosInstance.get<
          Array<{ attributeSetId: number; name: string }>
        >(API_URL_PIM_ATTRIBUTE_SETS);
        setConjuntosDelAlta(
          (data ?? []).filter((c) => CONJUNTOS_DEL_ALTA.includes(c.name)),
        );
      } catch {
        message.error("No se pudo abrir el alta del Catálogo");
      } finally {
        setPreparandoCatalogar(false);
      }
    };
    const { token } = theme.useToken();
    const styleColorSecondary = { color: token.colorTextSecondary };
    const styleColorTerciary = { color: token.colorTextTertiary };

    const { formProps, saveButtonProps, form } = useForm<any>({
      warnWhenUnsavedChanges: false,
    });

    useEffect(() => {
      if (configData) setThisConfigData(configData);
    }, [configData]);

    useEffect(() => {
      setLinkedData([]);
      setTextSearchValue("");
      appendData();
      const skusFromConfig = new Set(
        thisConfigData?.variations?.map(
          (variation: any) => variation?.mainCatalog?.sku,
        ),
      );
      setSelectedProducts(Array.from(skusFromConfig) as string[]);
    }, [searchValue]);

    useEffect(() => {
      const variationEnabled =
        thisConfigData?.variations?.[0]?.enabled ?? false;

      setActiveSale(variationEnabled);

      const screenH = window.innerHeight;
      // 50px menos que en el panel (xcons-docs#609): en la pantalla, arriba van el título y
      // abajo la barra de botones.
      const heightProduct = screenH - 350;
      const heightDetail = screenH - 595;
      setScreenHeightProduct(heightProduct);
      setScreenHeightDetail(heightDetail);
    }, [configData]);

    useEffect(() => {
      setTextSearchValue(thisConfigData?.name);
      if (thisConfigData && thisConfigData?.variations) {
        const selectedSkus = thisConfigData?.variations.map(
          (variation: any) => variation?.mainCatalog?.sku,
        );
        setSelectedProducts(selectedSkus);
        const selectedProductsData = thisConfigData?.variations.reduce(
          (acc: any, variation: any) => {
            acc[variation?.mainCatalog?.sku] = {
              sku: variation?.mainCatalog?.sku,
              name: variation?.mainCatalog?.name,
              manufacturer: variation?.mainCatalog?.manufacturer,
              unit: variation?.mainCatalog?.unit,
              image: variation?.mainCatalog?.image,
              factor: variation?.factor,
              enabled: variation?.enabled,
            };
            return acc;
          },
          {},
        );
        setSelectedProductData(selectedProductsData);
      }
    }, [thisConfigData]);

    const appendData = async (
      newPage = 1,
      skuOverride?: string,
      searchOverride?: string,
      selectedFilters: {
        priceFilter?: boolean;
        brandFilter?: string;
        colorFilter?: string;
        unitFilter?: string;
      } = {},
    ) => {
      const skuToFetch = skuOverride || thisConfigData;
      const limitPage = 20;
      const searchQuery = searchOverride ?? searchValue ?? skuToFetch?.name;

      setSelectedFilters(selectedFilters);

      if (loadingMore) return;

      if (searchOverride && newPage === 1) {
        setLinkedData([]);
        setPage(1);
        setHasMore(true);
      }
      setLoadingMore(true);
      setLoadingVirual(true);

      const queryParams = new URLSearchParams({
        ...{ usePriceFilter: `${selectedFilters?.priceFilter ?? false}` },
        ...(selectedFilters?.brandFilter && {
          BrandFilter: `${selectedFilters?.brandFilter},VARIAS`,
        }),
        ...(selectedFilters?.colorFilter && {
          ColorFilter: selectedFilters?.colorFilter,
        }),
        ...(selectedFilters?.unitFilter && {
          UnitFilter: selectedFilters?.unitFilter,
        }),
        // Sin nombre ni texto tipeado no se manda: URLSearchParams lo convertiría en la palabra
        // "undefined", y la API busca sola por el sku del seller (xcons-docs#616).
        ...(searchQuery && { searchQuery }),
        page: String(newPage),
        limit: String(limitPage),
      });

      try {
        const response = await axiosInstance.get(
          `${API_URL_LINKED_SEARCH}/${sellerCode}/search/${encodeURIComponent(
            skuToFetch.sku,
          )}?${queryParams.toString()}`,
        );

        setFilterOptions(response?.data?.meta?.filterOptions);

        if (
          response?.data &&
          response?.data?.data &&
          Array.isArray(response?.data?.data)
        ) {
          setLinkedData((prevData) => {
            const newData = response?.data?.data || [];
            // Cada página llega con objetos nuevos: los repetidos se reconocen por el sku.
            const vistos = new Set(prevData.map((item: any) => item?.sku));
            return [
              ...prevData,
              ...newData.filter((item: any) => !vistos.has(item?.sku)),
            ];
          });

          if (response?.data?.data?.length < limitPage) {
            setHasMore(false);
          }
        } else {
          setHasMore(false);
        }
      } catch (error: any) {
        console.log("Error fetching data", error.message);
      } finally {
        setLoadingMore(false);
        setLoadingVirual(false);
      }
    };

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      const list = e.currentTarget;
      const { scrollTop, clientHeight, scrollHeight } = list;

      if (
        scrollTop + clientHeight >= scrollHeight - 300 &&
        hasMore &&
        !loadingMore
      ) {
        appendData(page + 1, "", textSearchValue);
      }
    };

    const handleSelectProduct = useCallback(
      (id: string) => {
        setSelectedProducts((prev) => {
          const isAlreadySelected = prev.includes(id);

          setSelectedProductData(
            (prev: {
              [key: string]: {
                sku: string;
                factor: number;
                name: string;
                manufacturer: string;
                image: string;
              };
            }) => {
              if (isAlreadySelected) {
                const { [id]: _, ...rest } = prev;
                return rest;
              } else {
                const selectedProduct = linkedData.find(
                  (item) => item?.sku === id,
                );
                const factor = selectedProduct?.factor || 1;
                return {
                  ...prev,
                  [id]: {
                    sku: id,
                    factor,
                    name: selectedProduct?.name,
                    manufacturer: selectedProduct?.manufacturer,
                    image: selectedProduct?.image,
                  },
                };
              }
            },
          );

          return isAlreadySelected
            ? prev.filter((product) => product !== id)
            : [...prev, id];
        });
      },
      [linkedData, selectedProducts, selectedProductData],
    );

    const handleSave = useMemo(
      () => async (action: "save" | "delete", skuToDelete?: string) => {
        if (action === "delete") {
          const payload = {
            variations: Object.values(selectedProductData)
              .filter((product: any) => product?.sku !== skuToDelete)
              .map((product) => ({
                mainCatalogSku: product?.sku,
                factor: product?.factor,
              })),
          };
          setHoveredItemId("");
          setLoadingDrawer(true);
          try {
            await axiosInstance.put(
              `${API_URL_LINKED_SEARCH}/${sellerCode}/assign/${encodeURIComponent(
                thisConfigData?.sku,
              )}`,
              payload,
            );
            setSelectedProductData((prevData: any) => {
              if (skuToDelete !== undefined) {
                const { [skuToDelete]: _, ...rest } = prevData;
                return rest;
              } else {
                return prevData;
              }
            });
            setSelectedProducts((prevProducts: string[]) =>
              prevProducts.filter((product) => product !== skuToDelete),
            );
            onCambio?.();
          } catch (error: any) {
            message.error(t("message.productDeletionError"));
          } finally {
            setLoadingDrawer(false);
          }
        } else {
          const variations = (
            Object.values(selectedProductData) as {
              sku: string;
              factor: number;
            }[]
          ).map((product) => ({
            mainCatalogSku: product?.sku,
            factor: product?.factor,
          }));

          const payload = { variations };
          setLoadingDrawer(true);
          try {
            if (payload) {
              await axiosInstance.put(
                `${API_URL_LINKED_SEARCH}/${sellerCode}/assign/${encodeURIComponent(
                  thisConfigData?.sku,
                )}`,
                payload,
              );
            } else {
              message.info("No product sku to link");
              return;
            }
            onGuardado?.();
          } catch (error: any) {
            notification.error({
              message: t("message.configurationErrorUpdating"),
              description: error.message,
              placement: "topLeft",
            });
          } finally {
            setLoadingDrawer(false);
          }
        }
      },
      [
        sellerCode,
        thisConfigData,
        linkedData,
        selectedProducts,
        searchValue,
        selectedProductData,
        activeSale,
      ],
    );

    const hasVariations = thisConfigData?.variations?.some(
      (variation: any) => variation !== null,
    );

    const handleActiveSale = async (checked: boolean) => {
      setIsActiveSale(true);
      setActiveSale(checked);

      const action = checked ? "enable" : "disable";
      const payload = {
        mainCatalogSkus: (
          Object.values(selectedProductData) as { sku: string }[]
        ).map((item: any) => item.sku),
      };

      if (payload.mainCatalogSkus.length !== 0) {
        try {
          await axiosInstance.post(
            `${API_URL_LINKED_SEARCH}/massAction/mainCatalog/${sellerCode}/action/${action}`,
            payload,
          );
          message.success(
            checked ? "Activado correctamente!" : "Desactivado correctamente",
          );
        } catch (error) {
          message.error(t("message.massActionError", { action }));
        } finally {
          setIsActiveSale(false);
        }
      } else {
        message.info("No hay sku asociado para realizar esta acción");
        setIsActiveSale(false);
      }
    };

    /**
     * **+ Catalogar** reemplaza a Solicitar catalogación (xcons-docs#609): los operadores ya
     * pueden crear productos, así que en vez de pedirlo se abre el alta del Catálogo, con lo
     * que el seller subió de este producto ya cargado.
     *
     * El acceso al Catálogo ya lo resolvió `prepararCatalogar`, al abrir el botón. El SKU
     * Fabricante se **sugiere** del código entre paréntesis del nombre —"(833.74.962)"—: el
     * producto del seller no lo guarda, y el SKU del Catálogo se fija al primer guardado, así
     * que lo confirma una persona.
     */
    const catalogar = (attributeSetId: string) =>
      navigate(`/catalog/nuevo/edit?set=${attributeSetId}`, {
        state: {
          // La ficha vuelve acá: a este producto del seller, con la cola si había.
          volverAlAsociador: { ruta: location.pathname, state: location.state },
          precarga: {
            name: thisConfigData?.name,
            manufacturer: thisConfigData?.manufacturer,
            price: thisConfigData?.price,
            manufacturerSku: codigoEntreParentesis(thisConfigData?.name),
          },
        },
      });

    useEffect(() => {
      setEditedData({
        price: thisConfigData?.price,
        costPrice: thisConfigData?.costPrice,
        specialPrice: thisConfigData?.specialPrice,
        specialFromDate: thisConfigData?.specialFromDate,
        specialToDate: thisConfigData?.specialToDate,
        stock: thisConfigData?.stock,
        leadTime: thisConfigData?.leadTime,
      });
    }, [thisConfigData]);

    const handleToggleEditMode = () => {
      if (isEditMode) {
        // Cancel edit mode - reset to original data
        setEditedData({
          price: thisConfigData?.price,
          costPrice: thisConfigData?.costPrice,
          specialPrice: thisConfigData?.specialPrice,
          specialFromDate: thisConfigData?.specialFromDate,
          specialToDate: thisConfigData?.specialToDate,
          stock: thisConfigData?.stock,
          leadTime: thisConfigData?.leadTime,
        });

        setDetailsCollapseKey([]);
      } else {
        setDetailsCollapseKey(["1"]);
      }
      setIsEditMode(!isEditMode);
    };

    const handleSaveEditedData = async () => {
      try {
        setLoadingDrawer(true);

        const payload = {
          name: "Manual Update",
          skipTaxDeduction: true,
          items: [
            {
              sku: thisConfigData?.sku,
              name: thisConfigData?.name,
              price: editedData?.price ?? thisConfigData?.price,
              stock: editedData?.stock ?? thisConfigData?.stock,
              manufacturer: thisConfigData?.manufacturer,
              leadTime: editedData?.leadTime ?? thisConfigData?.leadTime,
              featured: thisConfigData?.featured ?? false,
              specialPrice:
                editedData?.specialPrice ?? thisConfigData?.specialPrice,
              specialFromDate:
                editedData?.specialFromDate ?? thisConfigData?.specialFromDate,
              specialToDate:
                editedData?.specialToDate ?? thisConfigData?.specialToDate,
              costPrice: editedData?.costPrice ?? thisConfigData?.costPrice,
            },
          ],
        };

        await axiosInstance.post(
          `${API_URL_LINKED_IMPORT}/${sellerCode}`,
          payload,
        );

        // Actualizar el estado local con los nuevos datos
        setThisConfigData((prev: any) => ({
          ...prev,
          price: editedData?.price ?? prev?.price,
          costPrice: editedData?.costPrice ?? prev?.costPrice,
          specialPrice: editedData?.specialPrice ?? prev?.specialPrice,
          specialFromDate: editedData?.specialFromDate ?? prev?.specialFromDate,
          specialToDate: editedData?.specialToDate ?? prev?.specialToDate,
          stock: editedData?.stock ?? prev?.stock,
          leadTime: editedData?.leadTime ?? prev?.leadTime,
        }));

        if (mainTableRefecth) {
          mainTableRefecth();
        }

        notification.success({
          message: "Producto actualizado correctamente",
        });

        setIsEditMode(false);
        setDetailsCollapseKey([]);
        onCambio?.();
      } catch (error: any) {
        notification.error({
          message: "Error al actualizar el producto",
          description: error?.response?.data?.message || error.message,
        });
        console.error("Error updating product:", error);
      } finally {
        setLoadingDrawer(false);
      }
    };

    useEffect(() => {
      if (isAccordionOpen) {
        form.setFieldsValue({
          price: selectedFilters?.priceFilter || false,
          brand: selectedFilters?.brandFilter
            ? selectedFilters?.brandFilter.split(",")
            : [],
          color: selectedFilters?.colorFilter
            ? selectedFilters?.colorFilter.split(",")
            : [],
          unit: selectedFilters?.unitFilter
            ? selectedFilters?.unitFilter.split(",")
            : [],
        });
      }
    }, [isAccordionOpen, selectedFilters, form]);

    const filterNames: Record<string, string> = {
      priceFilter: t("linkedProducts.modal.price"),
      brandFilter: t("filter.products.labelBrand"),
      colorFilter: "Color",
      unitFilter: "Unit",
    };

    const handleRemoveFilter = (
      filterKey: string,
      filterDeleteType: string,
    ) => {
      if (filterDeleteType === "all") {
        form.resetFields();
        setSelectedFilters({});
        appendData(1, undefined, textSearchValue, undefined);
      } else {
        const updatedFilters = { ...selectedFilters, [filterKey]: "" };
        setSelectedFilters(updatedFilters);
        if (filterKey === "priceFilter") {
          form.resetFields(["price"]);
        } else {
          form.setFieldsValue({ [filterKey]: undefined });
        }
        appendData(1, undefined, textSearchValue, updatedFilters);
      }
    };

    const pie = (
      <>
        {/* Atrás y Catalogar a la izquierda, Guardar a la derecha (xcons-docs#609). Con
            más productos en la cola, Guardar lleva flecha y pasa al siguiente; en el
            último, check y vuelve a la tabla. */}
        <Flex gap={8} justify="space-between" align="center">
          <Flex gap={8}>
            <Button icon={<ArrowLeftOutlined />} onClick={onAtras}>
              {t("buttons.back")}
            </Button>
            <Dropdown
              // Con clic y no al pasar el mouse: abrirlo puede dar el acceso al Catálogo.
              trigger={["click"]}
              onOpenChange={(abierto) => abierto && prepararCatalogar()}
              menu={{
                items: conjuntosDelAlta.length
                  ? conjuntosDelAlta.map((c) => ({
                      key: String(c.attributeSetId),
                      label: etiquetaConjunto(c.name),
                    }))
                  : [
                      {
                        key: "cargando",
                        disabled: true,
                        label: preparandoCatalogar ? "Cargando…" : "Sin tipos para dar de alta",
                      },
                    ],
                onClick: ({ key }) => key !== "cargando" && catalogar(key),
              }}
            >
              {/* El ícono del Catálogo en el menú, y el + de que agrega uno. */}
              <Button icon={<AppstoreOutlined />}>
                Catalogar
                <PlusOutlined />
              </Button>
            </Dropdown>
          </Flex>
          <SaveButton
            icon={haySiguiente ? <ArrowRightOutlined /> : <CheckOutlined />}
            iconPosition="end"
            onClick={async () => {
              if (isEditMode) {
                await handleSaveEditedData();
              }
              handleSave("save");
            }}
          >
            {t("buttons.save")}
          </SaveButton>
        </Flex>
      </>
    );

    return (
      // Sin margen propio: es una pantalla (xcons-docs#609), y el margen lo pone el layout, el
      // mismo del título y del Historial de abajo.
      <Flex vertical>
        <Spin spinning={loadingDrawer}>
          {/* Las dos columnas a la misma altura (xcons-docs#609): la más corta estira su
              última tarjeta hasta la otra. El `height: auto` le gana al `.ant-col` global
              de config.css, que con su 100% no las dejaba estirarse. */}
          <Row gutter={14} wrap justify="center" align="stretch">
            <Col
              xs={24}
              md={10}
              lg={10}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "auto",
              }}
            >
              <Card className="custom-card-product" style={{ flex: 1 }}>
                <Flex
                  align="center"
                  justify="space-between"
                  style={{
                    // El gris de los encabezados de tarjeta, como el Historial (xcons-docs#634).
                    backgroundColor: "#f0f0f0",
                    height: 40,
                    boxSizing: "border-box",
                    borderBottom: "1px solid #d9d9d9",
                    padding: "0 16px",
                  }}
                >
                  <Flex align="center" justify="start">
                    <Title
                      level={5}
                      style={{
                        ...styleColorSecondary,
                        margin: 0,
                        // 14px como Detalles y Productos asociados (xcons-docs#609).
                        fontSize: 14,
                      }}
                    >
                      {t("linkedProducts.modal.subTitle")}
                    </Title>
                    {!isEditMode ? (
                      <Button
                        type="link"
                        style={{ padding: "4px 8px", color: "black" }}
                        color="default"
                        onClick={handleToggleEditMode}
                      >
                        <EditOutlined />
                      </Button>
                    ) : (
                      <>
                        <Button
                          type="link"
                          style={{ padding: "4px 2px", color: "red" }}
                          onClick={handleToggleEditMode}
                          icon={<CloseOutlined />}
                          title="Cancelar"
                        />
                        <Button
                          type="link"
                          style={{ padding: "4px 2px", color: "green" }}
                          onClick={handleSaveEditedData}
                          icon={<CheckOutlined />}
                          iconPosition="end"
                          title="Guardar"
                        />
                      </>
                    )}
                  </Flex>

                  {/* Sólo asociando varios: con uno solo no hay "de cuántos". */}
                  {posicion && (
                    <Text style={{ ...styleColorTerciary }}>
                      <Divider
                        type="vertical"
                        style={{ marginRight: 18, height: 22 }}
                      />
                      <strong>{posicion.actual}</strong> / {posicion.total}
                    </Text>
                  )}
                </Flex>
                <Flex
                  justify="space-between"
                  align="center"
                  className="custom-card-product__child"
                >
                  <Text style={{ ...styleColorTerciary }}>
                    {t("linkedProducts.modal.yourSKU")}
                  </Text>
                  <Text>{thisConfigData?.sku}</Text>
                </Flex>
                <Flex
                  justify="space-between"
                  align="center"
                  className="custom-card-product__child"
                >
                  <Text style={{ ...styleColorTerciary }}>
                    {t("linkedProducts.modal.brand")}
                  </Text>
                  <Text>{thisConfigData?.manufacturer}</Text>
                </Flex>
                <Flex
                  justify="space-between"
                  align="center"
                  className="custom-card-product__child"
                >
                  <Text style={{ ...styleColorTerciary }}>
                    {t("products.import.form.label.price")}
                  </Text>
                  {isEditMode ? (
                    <InputNumber
                      value={editedData?.price}
                      onChange={(value) =>
                        setEditedData((prev: any) => ({
                          ...prev,
                          price: value,
                        }))
                      }
                      style={{ width: 155 }}
                      prefix="$"
                      min={0}
                      step={0.01}
                    />
                  ) : (
                    thisConfigData?.price && (
                      <NumberField
                        value={thisConfigData?.price}
                        style={{
                          marginLeft: "auto",
                        }}
                        options={{
                          style: "currency",
                          currency: "ARS",
                        }}
                      />
                    )
                  )}
                </Flex>
                <Flex
                  align="start"
                  vertical
                  className="custom-card-product__child--big"
                >
                  <Text style={{ ...styleColorTerciary }}>
                    {t("products.import.form.label.name")}
                  </Text>
                  <Text
                    style={{
                      minHeight: 66,
                      textAlign: "right",
                    }}
                  >
                    {thisConfigData?.name}
                  </Text>
                </Flex>

                {/* Las dos acciones de la ficha, no un dato: en su propia caja verde clara y con
                    los labels en bold, dentro de la fila (xcons-docs#634). */}
                <div
                  className="custom-card-product__child--big"
                  style={{ padding: "8px 16px" }}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{
                      height: 36,
                      padding: "0 12px",
                      borderRadius: token.borderRadius,
                      backgroundColor: token.colorPrimaryBg,
                    }}
                  >
                    <Flex justify="space-between">
                      <Checkbox>
                        <span
                          style={{ ...styleColorTerciary, fontWeight: 600 }}
                        >
                          {t("linkedProducts.modal.featured")}
                        </span>
                      </Checkbox>
                    </Flex>

                    <Divider
                      type="vertical"
                      style={{
                        height: 22,
                      }}
                    />

                    <Flex gap={10} align="center">
                      <Switch
                        loading={isActiveSale}
                        disabled={!hasVariations}
                        size="small"
                        checked={activeSale}
                        onChange={handleActiveSale}
                      />
                      <span style={{ ...styleColorTerciary, fontWeight: 600 }}>
                        {t("linkedProducts.modal.activeSale")}
                      </span>
                    </Flex>
                  </Flex>
                </div>
                <Collapse
                  expandIconPosition="end"
                  activeKey={detailsCollapseKey}
                  onChange={(keys) => setDetailsCollapseKey(keys as string[])}
                  ghost
                  className="custom-collapse-product"
                  items={[
                    {
                      key: "1",
                      label: (
                        <Title
                          level={5}
                          style={{
                            ...styleColorSecondary,
                            margin: 0,
                          }}
                        >
                          {t("linkedProducts.modal.details")}
                        </Title>
                      ),
                      children: (
                        <>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.cost")}
                            </Text>
                            {isEditMode ? (
                              <InputNumber
                                value={editedData?.costPrice}
                                onChange={(value) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    costPrice: value,
                                  }))
                                }
                                style={{ width: 155 }}
                                prefix="$"
                                min={0}
                                step={0.01}
                              />
                            ) : (
                              <Text>{thisConfigData?.costPrice ?? "-"}</Text>
                            )}
                          </Flex>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.specialPrice")}
                            </Text>
                            {isEditMode ? (
                              <InputNumber
                                value={editedData?.specialPrice}
                                onChange={(value) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    specialPrice: value,
                                  }))
                                }
                                style={{ width: 155 }}
                                prefix="$"
                                min={0}
                                step={0.01}
                              />
                            ) : (
                              <Text>
                                {thisConfigData?.specialPrice !== 0
                                  ? thisConfigData?.specialPrice
                                  : "-"}
                              </Text>
                            )}
                          </Flex>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.specialPriceFrom")}
                            </Text>
                            {isEditMode ? (
                              <DatePicker
                                showTime
                                format="YYYY-MM-DD HH:mm"
                                value={
                                  editedData?.specialFromDate
                                    ? dayjs(editedData?.specialFromDate)
                                    : null
                                }
                                onChange={(date) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    specialFromDate: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                style={{ width: 155 }}
                              />
                            ) : (
                              <Text>
                                {thisConfigData?.specialFromDate === null
                                  ? "-"
                                  : dayjs(
                                      thisConfigData?.specialFromDate,
                                    ).format("DD/MM/YYYY HH:mm")}
                              </Text>
                            )}
                          </Flex>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.specialPriceTo")}
                            </Text>
                            {isEditMode ? (
                              <DatePicker
                                showTime
                                format="YYYY-MM-DD HH:mm"
                                value={
                                  editedData?.specialToDate
                                    ? dayjs(editedData?.specialToDate)
                                    : null
                                }
                                onChange={(date) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    specialToDate: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                style={{ width: 155 }}
                              />
                            ) : (
                              <Text>
                                {thisConfigData?.specialToDate === null
                                  ? "-"
                                  : dayjs(thisConfigData?.specialToDate).format(
                                      "DD/MM/YYYY HH:mm",
                                    )}
                              </Text>
                            )}
                          </Flex>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.stock")}
                            </Text>
                            {isEditMode ? (
                              <InputNumber
                                value={editedData?.stock}
                                onChange={(value) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    stock: value,
                                  }))
                                }
                                style={{ width: 155 }}
                                step={1}
                              />
                            ) : (
                              <Text>{thisConfigData?.stock ?? "-"}</Text>
                            )}
                          </Flex>
                          <Flex
                            justify="space-between"
                            align="center"
                            className="custom-card-product__child"
                          >
                            <Text style={{ ...styleColorTerciary }}>
                              {t("linkedProducts.modal.leadtime")}
                            </Text>
                            {isEditMode ? (
                              <InputNumber
                                value={editedData?.leadTime}
                                onChange={(value) =>
                                  setEditedData((prev: any) => ({
                                    ...prev,
                                    leadTime: value,
                                  }))
                                }
                                style={{ width: 155 }}
                                min={0}
                                step={1}
                                addonAfter={t("products.show.tableDays")}
                              />
                            ) : (
                              <Text>
                                {thisConfigData?.leadTime !== 0
                                  ? `${thisConfigData?.leadTime} ${t(
                                      "products.show.tableDays",
                                    )}`
                                  : "-"}
                              </Text>
                            )}
                          </Flex>
                        </>
                      ),
                    },
                  ]}
                />
                <Collapse
                  expandIconPosition="end"
                  defaultActiveKey={["1"]}
                  ghost
                  className="custom-collapse-product"
                  items={[
                    {
                      key: "1",
                      label: (
                        <Flex gap={8}>
                          <Title
                            level={5}
                            style={{
                              ...styleColorSecondary,
                              margin: 0,
                            }}
                          >
                            {Object.keys(selectedProductData)?.length}{" "}
                            {Object.keys(selectedProductData)?.length > 1
                              ? t("linkedProducts.modal.0LinkedProduct")
                              : t("linkedProducts.modal.1LinkedProduct")}
                          </Title>

                          <ApiOutlined />
                        </Flex>
                      ),

                      children: (
                        <Flex
                          align="start"
                          className="custom-card-product__child--big"
                          style={{
                            borderBottom: 0,
                            height: screenHeightDetail,
                            overflowY: "auto",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <Text
                            style={{
                              ...styleColorSecondary,
                              minHeight: 130,
                              width: "100%",
                            }}
                          >
                            {Object.keys(selectedProductData)?.length > 0 ? (
                              <Flex
                                vertical
                                style={{
                                  marginBottom: 4,
                                }}
                                gap={10}
                              >
                                {Object.values(selectedProductData)?.map(
                                  (selectedItem: any, index: number) => (
                                    <Flex
                                      className="selectedCard fade-in-right"
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                      }}
                                      key={`${selectedItem?.sku}-${index}`}
                                    >
                                      <Flex
                                        align="start"
                                        gap={8}
                                        style={{
                                          width: "100%",
                                          backgroundColor:
                                            "rgba(0, 0, 0, 0.02)",
                                        }}
                                      >
                                        <Avatar
                                          style={{
                                            width: "33%",
                                            height: "100%",
                                            objectFit: "fill",
                                          }}
                                          shape="square"
                                          size={130}
                                          src={selectedItem?.image || noImage}
                                        />
                                        <Flex
                                          vertical
                                          style={{
                                            width: "65%",
                                            paddingRight: 8,
                                          }}
                                        >
                                          <Flex
                                            align="center"
                                            justify="end"
                                            style={{
                                              padding: "4px 0",
                                              marginBottom: 4,
                                              borderBottom:
                                                "1px solid rgba(0, 0, 0, 0.06)",
                                            }}
                                          >
                                            <Button
                                              onClick={() =>
                                                handleSave(
                                                  "delete",
                                                  selectedItem?.sku,
                                                )
                                              }
                                              className="selectedCard--button"
                                              danger
                                              iconPosition="end"
                                              type="text"
                                              size="small"
                                              style={{ width: 100 }}
                                              icon={<ApiOutlined />}
                                            >
                                              {t("button.unlink")}
                                            </Button>
                                          </Flex>
                                          <Text strong>
                                            {selectedItem?.manufacturer}
                                          </Text>
                                          <Text
                                            style={{
                                              ...styleColorSecondary,
                                              paddingBottom: 6,
                                            }}
                                          >
                                            {selectedItem?.name}
                                          </Text>
                                          <Flex>
                                            {Object.keys(selectedProductData)
                                              .length > 1 && (
                                              <Flex
                                                align="center"
                                                justify="space-between"
                                                style={{
                                                  width: "100%",
                                                  marginBottom: 4,
                                                }}
                                              >
                                                <span>Conversion</span>
                                                <InputNumber
                                                  size="small"
                                                  className="no-arrows"
                                                  style={{ width: 40 }}
                                                  onClick={(e) =>
                                                    e.stopPropagation()
                                                  }
                                                  placeholder="Factor"
                                                  defaultValue={
                                                    selectedItem?.factor || 1
                                                  }
                                                  min="0"
                                                  step="0.5"
                                                  onChange={(value) => {
                                                    const id =
                                                      selectedItem?.sku;
                                                    setSelectedProductData(
                                                      (prev: any) => ({
                                                        ...prev,
                                                        [id]: {
                                                          sku: id,
                                                          factor: value,
                                                          image:
                                                            selectedItem?.image,
                                                          manufacturer:
                                                            selectedItem?.manufacturer,
                                                          name: selectedItem?.name,
                                                        },
                                                      }),
                                                    );
                                                  }}
                                                />
                                              </Flex>
                                            )}
                                          </Flex>
                                        </Flex>
                                      </Flex>
                                    </Flex>
                                  ),
                                )}
                              </Flex>
                            ) : (
                              <Text>
                                {t(
                                  "linkedProducts.modal.thereArentLinkedProducts",
                                )}
                              </Text>
                            )}
                          </Text>
                        </Flex>
                      ),
                    },
                  ]}
                />
              </Card>
            </Col>
            <Col
              xs={24}
              md={14}
              lg={14}
              style={{
                display: "flex",
                flexDirection: "column",
                height: "auto",
              }}
            >
              <Card
                className="custom-card-catalog"
                style={{
                  borderBottom: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                }}
              >
                <Flex>
                  <Title
                    level={5}
                    style={{
                      ...styleColorSecondary,
                      margin: "0 0 10px 0",
                    }}
                  >
                    {t("linkedProducts.modal.storeCatalogProducts")}
                  </Title>
                </Flex>
                <Form layout="vertical">
                  {/* 8px, no los 24 de un Form.Item: abajo vienen los resultados (xcons-docs#609). */}
                  <Form.Item
                    name="linkedDataSearch"
                    style={{ marginBottom: 8 }}
                  >
                    <Flex gap={12}>
                      <Search
                        placeholder="search product"
                        value={textSearchValue}
                        onChange={(e) => setTextSearchValue(e.target.value)}
                        onSearch={(value, event) => {
                          event?.preventDefault();
                          appendData(1, "", textSearchValue);
                        }}
                      />
                      <Button
                        shape="circle"
                        icon={<FilterOutlined />}
                        onClick={() => setIsAccordionOpen((prev) => !prev)}
                        type={isAccordionOpen ? "primary" : "default"}
                      />
                    </Flex>
                  </Form.Item>
                </Form>
                <Flex>
                  {!isAccordionOpen && (
                    <Flex className="filter-tags">
                      {Object.entries(selectedFilters || {})
                        .filter(([key, value]) => value)
                        .map(([key, value]) => (
                          <Tag
                            key={key}
                            closable
                            onClose={() => handleRemoveFilter(key, "one")}
                            closeIcon={<CloseCircleOutlined />}
                          >
                            {filterNames[key]}:{" "}
                            {String(value).split(",").join(", ")}
                          </Tag>
                        ))}

                      {/* <Button
                        key={"deleteAll"}
                        onClick={() => handleRemoveFilter("", "all")}
                        shape="round"
                        size="small"
                      >
                        Clear filters
                      </Button> */}
                    </Flex>
                  )}

                  {/* Marca, Color y Unidad en una fila, y abajo el ±30% a la izquierda con
                      Limpiar y Filtrar a la derecha (xcons-docs#609). */}
                  <div
                    style={{
                      width: "100%",
                      display: isAccordionOpen ? "block" : "none",
                      padding: 16,
                      background: token.colorFillAlter,
                      borderRadius: token.borderRadiusLG,
                    }}
                  >
                    <Form
                      {...formProps}
                      layout="vertical"
                      onFinish={(values: any) => {
                        const selectedFilters = {
                          priceFilter: values?.price || false,
                          brandFilter: values?.brand?.join(",") || "",
                          colorFilter: values?.color?.join(",") || "",
                          unitFilter: values?.unit?.join(",") || "",
                        };

                        appendData(
                          1,
                          undefined,
                          textSearchValue,
                          selectedFilters,
                        );
                      }}
                    >
                      <Row gutter={12}>
                        <Col span={8}>
                          <Form.Item
                            style={{ marginBottom: 12 }}
                            label={
                              <span style={{ color: token.colorTextTertiary }}>
                                {t("filter.products.labelBrand")}
                              </span>
                            }
                            name="brand"
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              placeholder={t("filter.products.labelAll")}
                            >
                              {Object.entries(
                                filterOptions?.manufacturer || {},
                              ).map(([key, value]) => (
                                <Select.Option key={key} value={key}>
                                  {key} ({value as string})
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            style={{ marginBottom: 12 }}
                            label={
                              <span style={{ color: token.colorTextTertiary }}>
                                Color
                              </span>
                            }
                            name="color"
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              placeholder={t("filter.products.labelAll")}
                            >
                              {Object.entries(filterOptions?.color || {}).map(
                                ([key, value]) => (
                                  <Select.Option key={key} value={key}>
                                    {key} ({value as string})
                                  </Select.Option>
                                ),
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <Form.Item
                            style={{ marginBottom: 12 }}
                            label={
                              <span style={{ color: token.colorTextTertiary }}>
                                {t("products.show.tableUnit")}
                              </span>
                            }
                            name="unit"
                          >
                            <Select
                              allowClear
                              mode="multiple"
                              placeholder={t("filter.products.labelAll")}
                            >
                              {Object.entries(filterOptions?.unit || {}).map(
                                ([key, value]) => (
                                  <Select.Option key={key} value={key}>
                                    {key} ({value as string})
                                  </Select.Option>
                                ),
                              )}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Flex justify="space-between" align="center" gap={8}>
                        <Form.Item
                          style={{ marginBottom: 0 }}
                          name="price"
                          valuePropName="checked"
                        >
                          <Checkbox>{t("linkedProducts.modal.price")}</Checkbox>
                        </Form.Item>
                        <Flex gap={8}>
                          <Button
                            danger
                            onClick={() => handleRemoveFilter("", "all")}
                          >
                            {t("filter.button.clearFilters")}
                          </Button>
                          <Button
                            icon={<FilterOutlined />}
                            type="primary"
                            htmlType="submit"
                          >
                            {t("filter.button.filter")}
                          </Button>
                        </Flex>
                      </Flex>
                    </Form>
                  </div>
                </Flex>
              </Card>
              <Card className="virtualCard" style={{ flex: 1 }}>
                <Spin spinning={loadingVirual}>
                  <VirtualList
                    data={linkedData}
                    height={
                      isAccordionOpen
                        ? // Lo que ocupa el bloque de filtros abierto, en su fila compacta.
                          screenHeightProduct - 150
                        : screenHeightProduct
                    }
                    onScroll={handleScroll}
                    itemKey="sku"
                  >
                    {(item) => (
                      <div
                        key={item?.sku}
                        onMouseEnter={() => setHoveredItemId(item?.sku)}
                        onMouseLeave={() => setHoveredItemId("")}
                      >
                        <LinkedProductCard
                          t={t}
                          item={item}
                          linkedID={item?.sku}
                          isHovered={hoveredItemId === item?.sku}
                          isSelected={selectedProducts.includes(item?.sku)}
                          handleSelectProduct={handleSelectProduct}
                          selectedProducts={selectedProducts}
                          setSelectedProductData={setSelectedProductData}
                        />
                      </div>
                    )}
                  </VirtualList>
                </Spin>
              </Card>
            </Col>
          </Row>
        </Spin>
        {/* Fijo abajo de la pantalla cuando la pantalla le da dónde; si no, al final. */}
        {contenedorDelPie ? (
          createPortal(pie, contenedorDelPie)
        ) : (
          <div style={{ marginTop: 24 }}>{pie}</div>
        )}
      </Flex>
    );
  },
);
